/**
 * Pearlabs / Trasse public support contact.
 *
 * Interim company phone = Gabriel's line (support.html Call us, second number).
 * Swap SUPPORT_PHONE_* when a dedicated company number exists (P8).
 */
export const SUPPORT_EMAIL = 'pearnet104@gmail.com';

/** E.164 for tel: / wa.me */
export const SUPPORT_PHONE_E164 = '+254757926135';

export const SUPPORT_PHONE_DISPLAY = '+254 757 926 135';

/** Local Kenyan display used on marketing copy */
export const SUPPORT_PHONE_LOCAL = '0757 926 135';

export const SUPPORT_TEL_HREF = `tel:${SUPPORT_PHONE_E164}`;
export const SUPPORT_MAILTO_HREF = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_WHATSAPP_HREF = `https://wa.me/${SUPPORT_PHONE_E164.replace('+', '')}`;
export const SUPPORT_PAGE_HREF = '/support.html';
